import { render, staticRenderFns } from "./OpportunisticSavingPopup.vue?vue&type=template&id=6b404346&scoped=true"
import script from "./OpportunisticSavingPopup.vue?vue&type=script&lang=js"
export * from "./OpportunisticSavingPopup.vue?vue&type=script&lang=js"
import style0 from "./OpportunisticSavingPopup.vue?vue&type=style&index=0&id=6b404346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b404346",
  null
  
)

export default component.exports